<template>
  <v-container class="pa-0" fluid>
    <!-- Announcement Banner -->
    <!--<v-alert tile dense type="info" color="custom-alert" class="text-center" style="margin-bottom: 0px;" prominent>
      <p style="margin-top: 15px;" v-html="$t('namechange-info-html')"/>
    </v-alert>-->
    <v-container fluid class="color-new-light-grey" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h1 class="text-h1 mb-0 mt-6">{{ $t('header-text') }}</h1>
        </v-col>
        <v-col cols="12" class="text-center">
          <p>{{ $t('header-sub-text') }}</p>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="12" class="text-center">
          <announcements></announcements>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="color-new-light-grey" v-else>
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h1 class="text-h8 mt-0">{{ $t('header-text') }}</h1>
          <p>{{ $t('header-sub-text') }}</p>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="12" class="text-center">
          <announcements></announcements>
        </v-col>
      </v-row>
      <v-row justify="center" class="mb-3">
        <v-col cols="12">
          <v-btn tile block large color="success" @click="setStrongDialog(true)">
            {{ $t('login') }}
            <v-dialog v-model="showStrongLoginDialog"
                      :fullscreen="dialogSettings.fullscreen"
                      :scrollable="dialogSettings.scrollable"
                      :hide-overlay="dialogSettings.hideoverlay"
                      :transition="dialogSettings.transition"
                      :width="dialogSettings.width"
                      :max-width="dialogSettings.maxwidth">
              <v-card>
                <v-toolbar flat light v-if="dialogSettings.fullscreen">
                  <v-toolbar-title>{{ $t('login') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn light icon @click.native="setStrongDialog(false)">
                    <v-icon>fa-times</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-container class="color-new-light-grey fluid">
                  <v-row>
                    <v-col cols="12" class="mb-3">
                      <v-row justify="center">
                        <v-col cols="11" class="pl-12" style="position: relative;">
                          <v-icon color="primary" class="front-page arrow-icon">fas fa-chevron-right</v-icon>
                          <span class="text-body-1 font-weight-bold">{{ $t('home-text-2') }}</span>
                        </v-col>
                        <v-col cols="11" class="pl-12" style="position: relative;">
                          <v-icon color="primary" class="front-page arrow-icon">fas fa-chevron-right</v-icon>
                          <span class="text-body-1 font-weight-bold">{{ $t('home-text-3') }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container class="px-0 pt-0">
                  <v-row>
                    <v-col cols="12" class="white pt-0">
                      <v-tabs slider-color="color-new-link-blue"  :show-arrows=false @change="tabPageEvent">
                        <v-tab href="#tab-login-onlineid-strong" class="upperclass--text font-weight-bold text-overline color-new-link-blue--text">{{ $t('home-text-5') }}</v-tab>
                        <v-tab href="#tab-login-strong-strong" class="upperclass--text font-weight-bold text-overline color-new-link-blue--text">{{ $t('home-text-6') }}</v-tab>
                        <v-tab href="#tab-login-qr-code" class="upperclass--text font-weight-bold color-new-link-blue--text" v-if="showQRCodeLogin">QR-koodi</v-tab>
                        <v-tab-item value="tab-login-onlineid-strong">
                          <v-row no-gutters>
                            <v-col class="pa-6">
                              <login-onlineid></login-onlineid>
                            </v-col>
                          </v-row>
                        </v-tab-item>
                        <v-tab-item value="tab-login-strong-strong">
                          <login-strong></login-strong>
                        </v-tab-item>
                        <v-tab-item value="tab-login-qr-code" v-if="showQRCodeLogin">
                          <login-qr-code></login-qr-code>
                        </v-tab-item>
                      </v-tabs>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
                <navigation-footer></navigation-footer>
              </v-card>
            </v-dialog>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <section class="color-new-light-grey" v-if="$vuetify.breakpoint.mdAndUp">
      <v-container>
        <v-row justify="space-around">
          <v-col cols="12" sm="5">
            <h3 class="mt-0 text-h3 text-center">{{ $t('home-text-1') }}</h3>
            <v-row>
              <v-col cols="12" class="pl-12" style="position: relative;">
                <v-icon color="primary" class="front-page arrow-icon">fas fa-chevron-right</v-icon>
                <span class="text-h6">{{ $t('home-text-2') }}</span>
              </v-col>
              <v-col class="pl-12 pt-0">
                <span>{{ $t('home-text-2-1') }}</span>
              </v-col>
              <v-col cols="12" class="pl-12" style="position: relative;">
                <v-icon color="primary" class="front-page arrow-icon">fas fa-chevron-right</v-icon>
                <span class="text-h6">{{ $t('home-text-3') }}</span>
              </v-col>
              <v-col class="pl-12 pt-0">
                <span>{{ $t('home-text-3-1') }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="align-end" cols="12" sm="4">
            <v-card class="front-page login-card">
              <v-tabs grow slider-color="color-new-link-blue" slider-size="6" class="ok-tabs front-page-tabs" height="56px" @change="tabPageEvent">
                <v-tab href="#tab-login-onlineid" class="upperclass--text font-weight-bold color-new-link-blue--text">{{ $t('home-text-5') }}</v-tab>
                <v-tab href="#tab-login-strong" class="upperclass--text font-weight-bold color-new-link-blue--text">{{ $t('home-text-6') }}</v-tab>
                <v-tab-item value="tab-login-onlineid">
                  <v-row no-gutters>
                    <v-col class="pa-6">
                      <login-onlineid></login-onlineid>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item value="tab-login-strong">
                  <login-strong></login-strong>
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="white home-page white-section">
      <v-container class="light">
        <v-row justify="space-around">
          <v-col cols="12" sm="6">
            <h2 :class="{'pb-4 mt-0 text-h7' : $vuetify.breakpoint.smAndDown, 'pb-4 mt-0 text-h2' : $vuetify.breakpoint.mdAndUp }">{{ $t('home-text-7') }}</h2>
            <p>{{ $t('home-text-8') }}</p>
            <p>{{ $t('home-text-9') }}</p>
            <p>{{ $t('home-text-10') }}</p>
          </v-col>
          <v-col cols="12" sm="4">
            <v-row>
              <v-col cols="12" class="text-center pa-0">
                <v-icon style="font-size: 85px;" v-if="$vuetify.breakpoint.mdAndUp" color="color-new-link-blue">fas fa-question-circle</v-icon>
                <v-img v-else contain src="/static/images/faq-mobile.png" />
              </v-col>
              <v-col cols="12" :class="{'text-center' : $vuetify.breakpoint.mdAndUp }">
                <h3 :class="{'text-h7 mt-0' : $vuetify.breakpoint.smAndDown, 'text-h3 mt-0' : $vuetify.breakpoint.mdAndUp }">{{ $t('home-text-11') }}</h3>
                <p class="mb-0" :class="{'px-12' : $vuetify.breakpoint.mdAndUp }">{{ $t('home-text-12') }}</p>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn v-btn tile outlined color="color-new-link-blue" large to="/help">{{ $t('home-text-13') }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-container>
</template>

<script>
  import OnlineIDLogin from '@/components/Login/LoginOnlineID.vue'
  import QRCodeLogin from '@/components/Login/LoginQRCode.vue'
  import Footer from '@/components/Navigation/Footer.vue'
  import Announcements from '@/components/Announcements/Announcements.vue'
  import StrongLogin from '@/components/Login/LoginStrongAuthentication.vue'

  export default {
    data: function () {
      return {
        showStrongLoginDialog: false
      }
    },
    computed: {
      dialogSettings() {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      },
      showQRCodeLogin() {
        return false
        // return this.$vuetify.breakpoint.mdAndDown && process.env.VUE_APP_CONFIG_ENV === 'testing'
      }
    },
    methods: {
      setStrongDialog(val) {
        this.showStrongLoginDialog = val
        window.dispatchEvent(new Event('resize'))
      }
    },
    mounted() {
      if (this.$store.getters.authenticated) {
        this.$router.push('/front-page')
      }
    },
    components: {
      'login-onlineid': OnlineIDLogin,
      'login-strong': StrongLogin,
      'login-qr-code': QRCodeLogin,
      'navigation-footer': Footer,
      'announcements': Announcements
    }
  }
</script>

<style>
  .front-page.arrow-icon {
    position: absolute;
    top: 50%;
    bottom: 50%;
    left: 14px;
  }

  .v-slide-group__prev.v-slide-group__prev--disabled, .v-slide-group__next v-slide-group__next--disabled {
    display: none !important;
  }

  .v-tab {
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>

<i18n>
  {
  "fi": {
  "header-text": "Kirjaudu Oma B2 Impact-palveluun",
  "header-sub-text": "Saitko meiltä laskun? Oma B2 Impact -palvelussa voit hoitaa velka-asioitasi helposti ja turvallisesti.",
  "home-text-1": "Kirjaudu sisään",
  "home-text-2": "Asianumerolla ja Oma B2 Impact-tunnuksella, jotka löydät saamastasi kirjeestä.",
  "home-text-2-1": "Pääset helposti tarkastelemaan yksittäisen velan tietoja ja tekemään lyhennyksiä.",
  "home-text-3": "Pankkitunnuksilla tai mobiilivarmenteella (vain kuluttaja-asiakkaille)",
  "home-text-3-1": "Tunnistautumalla pankkitunnuksilla tai mobiilivarmenteella pääset tarkastelemaan kaikkia tietojasi.",
  "home-text-5": "Oma B2 Impact -tunnus",
  "home-text-6": "Vahva tunnistautuminen",
  "home-text-7": "Mikä on Oma B2 Impact?",
  "home-text-8": "Oma B2 Impact on B2 Impactin verkkopalvelu, jossa voit hoitaa velka-asioitasi silloin, kun se sinulle parhaiten sopii.",
  "home-text-9": "Oma B2 Impact -palvelussa maksat velkasi helposti ja turvallisesti. Voit myös tehdä itsellesi sopivan maksusuunnitelman ja lyhentää velkaasi joustavasti erissä, mikäli  maksaminen kertasuorituksena ei ole mahdollista. Palvelussa voit myös päivittää yhteystietojasi, tarkistaa saldosi ja laskusi tiedot, tai sopia uuden maksupäivän.",
  "home-text-10": "Jos haluat keskustella kanssamme henkilökohtaisesti, ota yhteyttä asiakaspalveluumme puhelimitse. Autamme sinua mielellämme!",
  "home-text-11": "Ohjeet & vinkit",
  "home-text-12": "Täältä löydät ohjeita velka-asioiden hoitoon sekä vastauksia usein kysyttyihin kysymyksiin.",
  "home-text-13": "Katso ohjeet ja vinkit",
  "namechange-info-html": "Oma OK -verkkopalvelu on nyt <b>Oma B2 Impact</b>! Löydät palvelumme jatkossa tästä uudesta osoitteesta <a class=\"color-new-light-bluegrey--text font-weight-bold\" href=\"https://online.b2-impact.fi/\" target=\"_blank\">online.b2-impact.fi</a>. Myös OK Perinnän nimi on vaihtunut, ja toimimme jatkossa nimellä <b>B2 Impact</b>. Muilta osin palvelumme säilyvät ennallaan."
  },
  "se": {
  "header-text": "Logga in till Min B2 Impact -tjänsten",
  "header-sub-text": "Har du fått en faktura av oss? I Min B2 Impact -tjänsten kan du sköta dina ärenden tryggt och enkelt.",
  "home-text-1": "Logga in",
  "home-text-2": "Med ärendenummer samt Min B2 Impact ID, som du hittar i brevet du fått av oss",
  "home-text-2-1": "Du kan enkelt göra betalningar samt hitta information om dina skulder",
  "home-text-3": "Genom att använda dina bankkoder eller ditt mobilcertifikat (endast for konsumentkunder)",
  "home-text-3-1": "Genom att logga in med dina bankkoder eller ditt mobilcertifikat kan du se information om alla dina ärenden.",
  "home-text-5": "Min B2 Impact ID",
  "home-text-6": "Bank-ID",
  "home-text-7": "Vad är Min B2 Impact?",
  "home-text-8": "Min B2 Impact är B2 Impacts nättjänst, var du kan sköta dina skuldärenden när det bäst passar dig.",
  "home-text-9": "I Min B2 Impact -tjänsten betalar du din skuld enkelt och tryggt. Du kan även göra upp en betalningsplan som passar dig samt betala din skuld i delar ifall du inte har möjlighet att betala den i sin helhet direkt.  I tjänsten kan du också uppdatera dina kontaktuppgifter, komma överens om en ny förfallodag samt kontrollera saldo och andra uppgifter om din skuld.",
  "home-text-10": "Om du personligen vill diskutera med oss kan du ringa vår kundtjänst. Vi hjälper dig gärna!",
  "home-text-11": "Frågor & svar",
  "home-text-12": "Här hittar du svar på de vanligaste frågorna om inkasso.",
  "home-text-13": "Se Frågor & svar",
  "namechange-info-html": "Min OK -tjänst är nu <b>Min B2 Impact</b>! Du hittar våra tjänster på denna nya adress <a class=\"color-new-light-bluegrey--text font-weight-bold\" href=\"https://online.b2-impact.fi/\" target=\"_blank\">online.b2-impact.fi</a>. Namnet på OK Indrivning har också ändrats; vi kommer att verka under namnet <b>B2 Impact</b>. I övrigt kommer våra tjänster att förbli oförändrade."
},
  "en": {
  "header-text": "Login to My B2 Impact service",
  "header-sub-text": "Did you receive a letter from us? Login to My B2 Impact service to easily and securely manage your debt.",
  "home-text-1": "Sign in",
  "home-text-2": "Using the case number and My B2 Impact code found in the letter you have received",
  "home-text-2-1": "You can make payments and view information about your case",
  "home-text-3": "Using online banking credentials or a mobile certificate (only for consumers)",
  "home-text-3-1": "Authenticated login allows you to see details about all your cases",
  "home-text-5": "My B2 Impact ID",
  "home-text-6": "Bank credentials",
  "home-text-7": "What is My B2 Impact service?",
  "home-text-8": "My B2 Impact is a web service provided by B2 Impact, where you can easily and safely manage your debts.",
  "home-text-9": "Once you log in, you can also create payment plans which enable you to make payments in multiple instalments if paying at once is not an option. In the service, you can also adjust due dates, view invoice information, or update your contact details.",
  "home-text-10": "If you wish to contact us directly, you're welcome to get in touch with our customer service via phone. We're here to help!",
  "home-text-11": "Help & tips",
  "home-text-12": "Here you can find the answers to the most common questions about collection",
  "home-text-13": "Go to help & tips",
  "namechange-info-html": "My OK -service is now <b>My B2 Impact</b>! From now on, you will find our services at this new address <a class=\"color-new-light-bluegrey--text font-weight-bold\" href=\"https://online.b2-impact.fi/\" target=\"_blank\">online.b2-impact.fi</a>. The name of OK Perintä has also changed, and we will be operating under the name <b>B2 Impact</b>. Otherwise, our services will remain the same."
}
  }
</i18n>
